export default __webpack_public_path__ + "static/media/projectmanagement.ca699678.png";